const entitySettings = {
  agencies: {
    actionName: 'loadAgency',
    groupTitle: 'AGENCIES',
    key: 'agencies',
    label: 'Agency',
    labelPlural: 'Agencies',
  },
  agents: {
    actionName: 'loadAgents',
    groupTitle: 'AGENTS',
    key: 'agents',
    label: 'Agent',
    labelPlural: 'Agents',
  },
  brands: {
    actionName: 'loadBrand',
    groupTitle: 'BRANDS',
    key: 'brands',
    label: 'Brand',
    labelPlural: 'Brands',
  },
  brandThemes: {
    actionName: 'loadBrandThemes',
    groupTitle: 'BRAND THEMES',
    key: 'brandThemes',
    label: 'Brand Theme',
    labelPlural: 'Brand Themes',
  },
  campaignQuoteItems: {
    actionName: 'loadCampaignQuoteItems',
    endpoint: 'campaign_quote_items',
    groupTitle: 'CAMPAIGN QUOTE ITEMS',
    key: 'campaignQuoteItems',
    label: 'Campaign Quote Item',
    labelPlural: 'Campaign Quote Items',
  },
  campaignQuoteTemplates: {
    actionName: 'loadCampaignQuoteTemplates',
    endpoint: 'campaign_quote_templates',
    groupTitle: 'CAMPAIGN QUOTE TEMPLATES',
    key: 'campaignQuoteTemplates',
    label: 'Campaign Quote Template',
    labelPlural: 'Campaign Quote Templates',
  },
  contacts: {
    actionName: 'loadContact',
    groupTitle: 'CONTACTS',
    key: 'contacts',
    label: 'Contact',
    labelPlural: 'Contacts',
  },
  campaigns: {
    actionName: 'loadCampaign',
    groupTitle: 'CAMPAIGNS',
    key: 'campaigns',
    label: 'Campaign',
    labelPlural: 'Campaigns',
  },
  geoSuburbs: {
    actionName: 'loadGeoSuburb',
    endpoint: 'geo_suburbs',
    groupTitle: 'SUBURBS',
    key: 'geoSuburbs',
    label: 'Suburb',
    labelPlural: 'Suburbs',
  },
  portals: {
    actionName: 'loadPortal',
    groupTitle: 'PORTALS',
    key: 'portals',
    label: 'Portal',
    labelPlural: 'Portals',
  },
  providerPriceLists: {
    actionName: 'loadProviderPriceList',
    endpoint: 'provider_price_lists',
    groupTitle: 'PRICE LISTS',
    key: 'providerPriceLists',
    label: 'Price List',
    labelPlural: 'Price Lists',
  },
  providerPackages: {
    actionName: 'loadProviderPackage',
    groupTitle: 'PROVIDER PACKAGES',
    key: 'providerPackages',
    label: 'Provider Package',
    labelPlural: 'Provider Packages',
  },
  providers: {
    actionName: 'loadProvider',
    groupTitle: 'PROVIDERS',
    key: 'providers',
    label: 'Provider',
    labelPlural: 'Providers',
  },
  publications: {
    actionName: 'loadPublication',
    groupTitle: 'PUBLICATIONS',
    key: 'publications',
    label: 'Publication',
    labelPlural: 'Publications',
  },
  serviceProducts: {
    actionName: 'loadServiceProduct',
    groupTitle: 'PRODUCTS',
    key: 'serviceProducts',
    label: 'Product',
    labelPlural: 'Products',
  },
  services: {
    actionName: 'loadService',
    groupTitle: 'SERVICES',
    key: 'services',
    label: 'Service',
    labelPlural: 'Services',
  },
  tags: {
    actionName: 'loadTag',
    groupTitle: 'TAGS',
    key: 'tags',
    label: 'Tag',
    labelPlural: 'Tags',
  },
  trainingCourses: {
    actionName: 'loadTrainingCourse',
    groupTitle: 'TRAINING COURSES',
    key: 'trainingCourses',
    label: 'Course',
    labelPlural: 'Courses',
  },
  trainingLessons: {
    actionName: 'loadTrainingLesson',
    groupTitle: 'TRAINING LESSONS',
    key: 'trainingLessons',
    label: 'Lesson',
    labelPlural: 'Lessons',
  },
  trainingModules: {
    actionName: 'loadTrainingModule',
    groupTitle: 'TRAINING MODULES',
    key: 'trainingModules',
    label: 'Module',
    labelPlural: 'Modules',
  },
  users: {
    actionName: 'loadUser',
    groupTitle: 'USERS',
    key: 'users',
    label: 'User',
    labelPlural: 'Users',
  },
}

export default entitySettings
